import React from "react";
import CourseCard from "../CourseCard/CourseCard";

export default class MyLearningPlan extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      account: this.props.account,
      user_learning_plan: this.props.user_learning_plan,
      courses: this.props.courses || [],
      course_preview: this.props.course_preview,
      user_id: this.props.user_id,
    };
  }

  componentDidMount() {
    var self = this;

    var eventMethod = window.addEventListener
      ? "addEventListener"
      : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

    // listen to message from child window
    eventer(
      messageEvent,
      function (e) {
        if (e && e.data && e.data == "assessmentCompleted") {
          //console.log('assessment completed');
          if ($(".modal-footer:hidden")) {
            $(".modal-footer").show();
          }
          self.refresh();
        }
      },
      false
    );

    if (typeof window.MyCoursesDidMount == "function") {
      window.MyCoursesDidMount();
    }
  }

  render() {
    //console.log('this.state.user_learning_plan', this.state.learning_plan_courses, this.state.learning_plan_assessments);
    var self = this;

    if (this.state.courses && this.state.courses.length > 0) {
      var passed_courses = [];
      var courses = this.state.courses.map(function (course) {
        if (!course.postTestPassed) {
          return (
            <CourseCard
              key={course.course_id}
              {...course}
              learning_plan_mode={true}
              user_id={self.state.user_id}
              course_preview={self.state.course_preview}
              account={self.state.account}
            />
          );
        } else {
          passed_courses.push(
            <CourseCard
              key={course.course_id}
              {...course}
              learning_plan_mode={true}
              user_id={self.state.user_id}
              course_preview={self.state.course_preview}
              account={self.state.account}
            />
          );
        }
      });

      return (
        <div className="my-courses" ref="container">
          {courses}
          {passed_courses.length > 0 ? (
            <div>
              <h2 style={{ marginTop: "40px", marginBottom: "10px" }}>
                Completed ({passed_courses.length})
              </h2>
              {passed_courses}
            </div>
          ) : null}
        </div>
      );
    } else {
      return (
        <div className="my-courses" ref="container">
          <div className="no-courses-jumbotron">
            <h2>You don't have any courses yet.</h2>
          </div>
        </div>
      );
    }
  }

  /**
   * Helper methods
   */
  refresh() {
    var self = this;
    //console.log('refresh!', this.props.refresh_user_learning_plan_path);
    $.ajax({
      type: "POST",
      url: this.props.refresh_user_learning_plan_path,
    }).done(function (data) {
      //console.log('refresh_user_learning_plan_path', data);
      self.setState({
        user_learning_plan: data.user_learning_plan,
        courses: data.courses,
      });
      $(window).trigger("assessmentCompleted", data);
    });
  }

  // findCourse(id) {
  // 	if (this.state.courses && this.state.courses.length) {
  // 		for (var i = 0, ilen = this.state.courses.length; i < ilen; i++) {
  // 			if (this.state.courses[i].course_id == id) {
  // 				return this.state.courses[i];
  // 			}
  // 		}
  // 	}
  // }

  // findCourseIndex(id) {
  // 	if (this.state.courses && this.state.courses.length) {
  // 		for (var i = 0, ilen = this.state.courses.length; i < ilen; i++) {
  // 			if (this.state.courses[i].course_id == id) {
  // 				return i;
  // 			}
  // 		}
  // 	}
  // }
}
